
import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import { alpha, styled } from '@mui/material/styles';
import { Auth, }         from "aws-amplify";
import { CognitoUser,  CognitoUserAttribute, } from 'amazon-cognito-identity-js';

import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import InputAdornment from '@mui/material/InputAdornment';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { CircularProgress } from '@mui/material'
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useSnackbar } from 'notistack';

const theme = createTheme();

enum SigninPhase{
  Init,
  SendingOTP,
  OTPSent,
  OTPVerifying,
  OTPVerified
}

interface SigninSteps{
  phase:      SigninPhase;
  phoneNum?:  string;
  user?:      CognitoUser;
}

export default function SignIn() {

  const [step, setStep] = useState<SigninSteps>({phase: SigninPhase.Init})
  const [verifyCode, setVerifyCode] = useState<string>('')
  const [phoneNum, setPhoneNum] = useState<string>('')

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>)  => {
    event.preventDefault();
    console.dir(event)
    const data = new FormData(event.currentTarget);
    console.dir(data)
    console.dir(step)

    if( step.phase == SigninPhase.Init ){
      const inputs = {
        phone: data.get('phoneNum'),
        password: data.get('password'),
      }
      console.log(inputs);
      const phoneNum = ('+65' + data.get('phoneNum'))?.toString()??"";

      try {
        setStep( {phase: SigninPhase.SendingOTP, phoneNum: phoneNum} );

        const user = await Auth.signIn(phoneNum);
        console.log('signIn called')
        console.dir(user);
        setStep({phase: SigninPhase.OTPSent, phoneNum: phoneNum, user: user});

        console.log(user);
      } catch (error: any) {
          console.log('error signing up:', error);
          console.dir(error)
          enqueueSnackbar('error signing in: ' + error, { variant: 'warning' });
          setStep( {phase: SigninPhase.Init, phoneNum: phoneNum} );
      }
    }
    else if( step.phase == SigninPhase.OTPSent || step.phase == SigninPhase.OTPVerifying ){

      console.log("to verify")

      const phoneNum = step.phoneNum ?? ""
      console.log({
        phoneNum: phoneNum, // data.get('phoneNum'),
        verifyCode: data.get('verifyCode'),
      })
      console.log(phoneNum)

      try
      {

        setStep({phase: SigninPhase.OTPVerifying, phoneNum: phoneNum, user: step.user});
        // const user = await Auth.currentUserPoolUser();
        // console.dir(user);

        const userName = phoneNum // ('+65' + data.get('phoneNum'))?.toString()??"";
        const verifyCode = data.get('verifyCode')?.toString()??""
        console.log({
          userName: userName,
          verifyCode: verifyCode
        });
        console.dir(step)
        // const res = await Auth.confirmSignIn( step.user, verifyCode);
        const res = await Auth.sendCustomChallengeAnswer(step.user, verifyCode )
        console.dir(res)

        const authUser = await Auth.currentAuthenticatedUser();

        setStep({phase: SigninPhase.OTPVerified, phoneNum: phoneNum});
        setTimeout(() => navigate('/'), 2000);
      } catch (error) {
          console.log('error confirming sign up: ', error);
          enqueueSnackbar('error signing in: ' + error, { variant: 'warning' });
          setStep({...step, phase: SigninPhase.OTPSent})
      }
    }

  };

  function onChange(value: any) {
    console.log("Captcha value:", value);
  }

  const BtnSendOTP = (props: any) => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        return;
      }

      const token = await executeRecaptcha('yourAction');
      // Do whatever you want with the token
      console.log(token.slice(0, 20))


    }, [executeRecaptcha]);

    // You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
      handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    return <Button
      type="submit"
      {...props}
      fullWidth
      variant="contained"
      endIcon={<SendToMobileIcon />}
      onClick={handleReCaptchaVerify}
    >
      Send OTP
    </Button>;
    // return <button onClick={handleReCaptchaVerify}>Verify recaptcha</button>;
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Ldt9CsgAAAAAEfXA5XP6Ro_G8TfIAfFFhICfSxO">
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',

            }}
          >
            <Box component="img"
              sx={{
                height: '170px',
                paddingY: '20px',
              }}
              alt="logo"
              src="/icons/banner-6.png"
            />
            <Typography component="h1" variant="h5" pt='15px'>
              Group Host Login
            </Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} key='theform'>
              <Grid container spacing={2}>

                <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      id="phoneNum"
                      label="Phone Number"
                      name="phoneNum"
                      key='phone-num'
                      // defaultValue=''
                      type='number'
                      disabled={step.phase!=SigninPhase.Init}
                      value={phoneNum}
                      onChange={(e:any)=>{
                        e.preventDefault();
                        if(e.target.value.length > 8 ){
                          return
                        }
                        setPhoneNum(e.target.value)
                        console.log(e.target.value)
                      }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">+65</InputAdornment>,
                        endAdornment: <InputAdornment position="end" onClick={()=>{  console.log('...') }}>
                                        <BtnSendOTP disabled={step.phase!=SigninPhase.Init || (phoneNum.length !=8)} />
                                      </InputAdornment>
                      }}
                      sx={{
                        'input[type=number]::-webkit-inner-spin-button': {
                          // '-webkit-appearance': 'none',
                          MozAppearance: 'none',
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                    />
                </Grid>
                { (step.phase == SigninPhase.OTPSent || step.phase == SigninPhase.OTPVerifying )&&
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      id="verifyCode"
                      // value={verifyCode}
                      label="Verification Code"
                      name="verifyCode"
                      type='number'
                      disabled={false}
                      InputProps={{
                        endAdornment: <InputAdornment position="end" onClick={()=>{  console.log('...') }}>

                                      </InputAdornment>

                      }}
                      // onChange={e => setVerifyCode(e.target.value)}

                      sx={{
                        'input[type=number]::-webkit-inner-spin-button': {
                          // '-webkit-appearance': 'none',
                          MozAppearance: 'none',
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                    />
                  </Grid>
                }
                { (step.phase == SigninPhase.OTPSent || step.phase == SigninPhase.OTPVerifying )&&
                  <Grid item xs={12}>
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 0, mb: 2 }}
                      disabled={step.phase == SigninPhase.OTPVerifying}
                    >
                      Login
                    </Button>
                  </Grid>
                }
                { (step.phase == SigninPhase.OTPVerified )&&
                  <Grid item xs={12}>
                    <Typography component="h1" variant="h5" align='center' sx={{ mt: 0, mb: 2 }}
                    >
                      Loggined !
                    </Typography>
                    <CircularProgress sx={{align:'center'}} />
                  </Grid>
                }
              </Grid>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Link href="/#/signup" variant="body2">
                    Dont have an account? Sign up
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>

        </Container>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}


export {
  SignIn
}
